import styles from './PageProductValueSummaries.module.css';
import valueSummaries from './PageProductValueSummaries.json';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import classNames from 'classnames';
import PageProductCallToActionBasic from './PageProductCallToActionBasic.js';
import PageProductCallToActionRenew from './PageProductCallToActionRenew.js';
import LinkAuthFlow from './LinkAuthFlow.js';

function PageProductValueSummaries() {
  const {
    productSku: product,
    showCallToActionRenew,
    showPageProductFeatureLearnMoreCTA,
    callToActionDefaultText,
    pageProductFeatureLearnMoreUrl,
    callToActionPrecopyText,
    showPortfolioValuePropositionsSection,
    valuePropositionTitleText,
    showPageProductStockScreenerGate,
  } = useSearchParamOrDefaultProps();
  const { summaryFields } = valueSummaries[product];

  const isPrimaryProductRegisteredOnly = product === 'RegisteredOnly';
  const shouldRenderCallToActionRenew =
    showCallToActionRenew === 'true' && !isPrimaryProductRegisteredOnly;
  const shouldRenderLearnMoreLink =
    showPageProductFeatureLearnMoreCTA === 'true';
  const showPropositionTitle =
    valuePropositionTitleText &&
    showPageProductStockScreenerGate &&
    showPortfolioValuePropositionsSection !== 'true';
  //If the portfolio VP section is to be shown, the valuePropositionTitleText will be placed there.

  return (
    <section className={styles.PageProductValueSummaries}>
      {showPropositionTitle && (
        <div className={styles.valuePropositionTitle}>
          {valuePropositionTitleText}
        </div>
      )}
      <ul
        className={classNames(styles.valuePropositionSummariesList, {
          [styles.list1]: summaryFields.length === 1,
          [styles.list2]: summaryFields.length === 2,
          [styles.list3]: summaryFields.length === 3,
          [styles.list4]: summaryFields.length === 4,
          [styles.list5]: summaryFields.length === 5,
          [styles.list6]: summaryFields.length === 6,
        })}
      >
        {summaryFields.map(
          (
            {
              subtitle,
              description,
              iconUrl,
              liveStreamIcon,
              newFlag,
              disclaimer,
            },
            i,
          ) => {
            return (
              <li
                className={styles.valuePropositionSummaryItem}
                key={i + iconUrl}
              >
                <div className={styles.iconSubtitleFlex}>
                  <img
                    className={styles.icon}
                    src={iconUrl}
                    alt={styles.subtitle}
                  />
                  <div className={styles.subtitleWrapper}>
                    {liveStreamIcon && (
                      <img src={liveStreamIcon} alt="LiveStream" />
                    )}
                    <h3 className={styles.subtitle}>{subtitle}</h3>
                    {newFlag && (
                      <div className={styles.newFlag}>
                        <img src={newFlag} alt="New" />
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className={classNames(styles.description, {
                    [styles.descriptionIndent]: liveStreamIcon,
                  })}
                >
                  {description}
                  {disclaimer && (
                    <p className={styles.valuePropositionDisclaimer}>
                      {disclaimer}
                    </p>
                  )}
                </div>
              </li>
            );
          },
        )}
        {!shouldRenderLearnMoreLink && (
          <li className={classNames(styles.callToActionItem)}>
            <div className={styles.callToActionLink}>
              {shouldRenderCallToActionRenew ? (
                <PageProductCallToActionRenew
                  flexDirection="column"
                  margin="0"
                  boxShadow={'0px 4px 4px 0px #00000040'}
                  orTextColor="#000000"
                />
              ) : (
                <PageProductCallToActionBasic
                  flexDirection="column"
                  margin="0"
                  showPrice={false}
                  boxShadow={'0px 4px 4px 0px #00000040'}
                  isPageProductValueSummaries
                />
              )}
            </div>
          </li>
        )}
      </ul>
      {shouldRenderLearnMoreLink && (
        <div className={styles.subscribeContainer} id="subscribeBtn">
          <div className={styles.callToActionPrecopyText}>
            {callToActionPrecopyText}
          </div>
          <button className={styles.subscribeButton}>
            <LinkAuthFlow
              contentType={'page'}
              modalType={'signUp'}
              productSku={product}
              className={styles.basicCallToActionPortfolio}
            >
              {callToActionDefaultText}
            </LinkAuthFlow>
          </button>
          <button className={styles.learnMoreBtn}>
            <a
              href={pageProductFeatureLearnMoreUrl}
              target="_blank"
              rel="noreferrer"
            >
              LEARN MORE
            </a>
          </button>
        </div>
      )}
    </section>
  );
}

export default PageProductValueSummaries;
